import { createGlobalStyle } from "styled-components";



export const GlobalStyle = createGlobalStyle`

  :root{
    --pink: #fb804bcc;
    --black: #212121;
    --green: #23ce6b;
    --blue: #016fb9;
    scroll-padding-top: 10rem;

    /* Card theming variables (default = dark theme) */
    --card-bg: #2b2b2b;
    --card-text: #FFFFFF;
    --card-link: #FFFFFF;
    --card-border: rgba(255,255,255,0.06);

    &.light{

      body{
        transition: 0.5s;
        background-color: #f5f5f5;
        color: var(--black);
      }

      .logo{
        color: var(--black);
      }

      header.header-fixed{
        transition: 0.5s;
        background-color: #f5f5f550;
        a{
          transition: 0.5s;
          color: black;
        }
        .menu,.menu:before, .menu:after{
          background-color: var(--black); 
        }
        .menu.active{
          background-color: transparent;
        }
      }

      footer.footer{
        transition: 0.5s;
        background-color: rgba(0,0,0,0.1);
        color: var(--black);
      }
      /* Light theme card variables */
      --card-bg: #FFFFFF;
      --card-text: var(--black);
      --card-link: var(--blue);
      --card-border: rgba(0,0,0,0.08);

      form{
        input,textarea{
          transition: 0.5s;
          border: solid 1px var(--black);
          color: var(--black);
          &::placeholder{
            transition: 0.5s;
            color: var(--black);
          }
        }
      }

    }
  }



  ul, li {
    text-decoration: none;
    list-style: none;
    margin: 0;
    padding:0;
  }

  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html{
    font-size: clamp(62.5%, 1.2vw, 65%);
  }

  body{
    font-size: 1.6rem;
    -webkit-font-smoothing: antialiased;
    background-color: var(--black);
    background-image:
      radial-gradient(ellipse 80% 50% at 10% 0%, rgba(35, 206, 107, 0.18) 0%, transparent 60%),
      radial-gradient(ellipse 60% 40% at 90% 100%, rgba(35, 206, 107, 0.13) 0%, transparent 55%);
    background-attachment: fixed;
    color: #FFFF;
  }

  body, input, textarea, button{
    font-family: 'Red Hat Display', sans-serif;
    font-weight: 400;
  }

  a{
    text-decoration: none;
  }

  html.light hr {
    border-top: 1px solid rgba(33,33,33,0.18);
    background: none;
    height: 0;
  }

  button, .button{
    border: none;
    cursor: pointer;
    background-color: var(--green);
    color: #FFFF;
    border-radius: 2rem;
    font-weight: 500;
    transition: filter 0.25s;
    &:hover{
      filter: brightness(0.8);
    }
  }

  button:disabled, .button:disabled{
    filter: brightness(0.8);
    cursor: not-allowed;
  }


  .logo{
    font-size: 3rem;
    color: #FFFF;
    &::first-letter{
      color: var(--green);
    }
  }

  /* Animazioni di reveal — vedi components/Reveal.
     Sostituiscono le classi di animate.css, che era caricata da CDN solo per
     queste quattro. La classe .reveal la aggiunge React via IntersectionObserver;
     con prefers-reduced-motion il contenuto resta comunque visibile. */
  @keyframes revealFadeInUp{
    from{ opacity: 0; transform: translate3d(0, 40px, 0); }
    to{ opacity: 1; transform: none; }
  }
  @keyframes revealFadeInLeft{
    from{ opacity: 0; transform: translate3d(-40px, 0, 0); }
    to{ opacity: 1; transform: none; }
  }
  @keyframes revealFadeInRight{
    from{ opacity: 0; transform: translate3d(40px, 0, 0); }
    to{ opacity: 1; transform: none; }
  }
  @keyframes revealFlipInX{
    from{ opacity: 0; transform: perspective(400px) rotate3d(1, 0, 0, 70deg); }
    40%{ transform: perspective(400px) rotate3d(1, 0, 0, -20deg); }
    60%{ opacity: 1; transform: perspective(400px) rotate3d(1, 0, 0, 10deg); }
    80%{ transform: perspective(400px) rotate3d(1, 0, 0, -5deg); }
    to{ opacity: 1; transform: perspective(400px); }
  }

  .reveal{
    opacity: 0;
  }

  .reveal--in{
    animation-duration: 0.8s;
    /* both: tiene l'elemento a opacity 0 anche durante animation-delay */
    animation-fill-mode: both;
  }

  .reveal--fadeInUp{ animation-name: revealFadeInUp; }
  .reveal--fadeInLeft{ animation-name: revealFadeInLeft; }
  .reveal--fadeInRight{ animation-name: revealFadeInRight; }
  .reveal--flipInX{ animation-name: revealFlipInX; backface-visibility: visible; }

  @media (prefers-reduced-motion: reduce){
    .reveal{
      opacity: 1;
      animation: none !important;
    }
  }

`